export default {
  props: {
    label: {
      type: String,
      default: undefined,
    },
    labelColor: {
      type: String,
      default: '#fff',
    },
    labelFontSize: {
      type: [Number, String],
      default: 24,
    },
  },
  computed: {
    labelStyle() {
      return {
        color: this.labelColor,
        fontSize: `${this.labelFontSize}px`,
      };
    },
  },
};
